import React, { useState, useEffect, useContext } from "react";
import { Store } from "react-notifications-component";
import classes from "./GetHistory.module.css";
import axios from "axios";
import AllHistory from "./GetHistoryTabs/AllHistory";
import SupplyHistory from "./GetHistoryTabs/SupplyHistory";
import SalesHistory from "./GetHistoryTabs/SalesHistory";
import PriceHistory from "./GetHistoryTabs/PriceHistory";
import PermissionContext from "../../Store/permission-context";
import DatePicker, {
  DateObject,
  getAllDatesInRange,
} from "react-multi-date-picker";
// import { DateRangePicker } from "rsuite";
import {
  Row,
  Col,
  Form,
  Card,
  Button,
  Table,
  Tabs,
  Tab,
} from "react-bootstrap";
import { AutoComplete, Divider } from "rsuite";
import ProcessingModal from "./Modals/ProcessingModal";

const GetHistory = () => {
  const [Dates, setDates] = useState("");
  const [AllDates, setAllDates] = useState([]);
  const [DateCategory, setDateCategory] = useState("specific");
  const [DatesSelected, setDatesSelected] = useState([]);
  const [SingleDate, setSingleDate] = useState("");
  const [DatesToSend, setDatesToSend] = useState({});
  const [DisplayTab, setDisplayTab] = useState(false);
  const [disableButton, setdisableButton] = useState(false);
  const [causeChange, setcauseChange] = useState(false);
  const [AllHistoryRecord, setAllHistoryRecord] = useState([]);
  const [AllSupplyHistory, setAllSupplyHistory] = useState([]);
  const [AllSalesHistory, setAllSalesHistory] = useState([]);
  const [AllPriceHistory, setAllPriceHistory] = useState([]);
  const [AxiosError, setAxiosError] = useState("");
  const [TableToShow, setTableToShow] = useState(-1);
  const [ShowProcessing, setShowProcessing] = useState(false);
  const [AllGoodNames, setAllGoodNames] = useState([]);
  const [Itemname, setItemname] = useState("");
  const [Title, setTitle] = useState("");
  const PCtx = useContext(PermissionContext);

  useEffect(() => {
    let Allnames = [];
    let AllIDs = [];
    const getData = async () => {
      let AllGoods = await PCtx.connectAxios("getallgoods.php", "");

      for (var y = 0; y < AllGoods.length; y++) {
        AllIDs[y] = AllGoods[y][0];
        Allnames[y] = AllGoods[y][1];
      }
    };
    getData();
    setAllGoodNames(Allnames);
  }, []);

  useEffect(() => {
    console.log(AxiosError);
  }, [AxiosError]);

  const dateCategoryChange = (e) => {
    if (e.target.checked) {
      setDateCategory(e.target.value);
      setDates("");
    }
  };

  const getItemnameSelection = () => {};
  const getTypedText = () => {};

  const GetTheHistory = async () => {
    if (DatesSelected.length <= 31) {
      setShowProcessing(true);
      setDisplayTab(false);

      let RecordHistory = await PCtx.connectAxios(
        "getitemallhistory.php",
        DatesToSend
      );
      // console.log(RecordHistory);
      let MergedHistory = [
        ...RecordHistory.Supply,
        ...RecordHistory.Sales,
        ...RecordHistory.Price,
      ];

      setAllHistoryRecord(MergedHistory);
      setAllSupplyHistory(RecordHistory.Supply);
      setAllSalesHistory(RecordHistory.Sales);
      setAllPriceHistory(RecordHistory.Price);

      setcauseChange(!causeChange);
      setDisplayTab(true);
      setShowProcessing(false);
    } else {
      PCtx.displayAlert(
        "TOO MANY DAYS",
        "Oops! You cannot select more than 31 days. Please pick lower dates range.",
        "danger",
        3000
      );
    }
  };

  //This is to make sure that the dates are selected before Generate Button is clicked.
  useEffect(() => {
    let dts = DateCategory === "specific" ? SingleDate : DatesSelected;
    let datats = {
      dates: dts,
      type: DateCategory,
      Category: "Group",
      itemname: Itemname,
    };
    setDatesToSend(datats);
    Dates === "" ? setdisableButton(true) : setdisableButton(false);
  }, [DatesSelected, SingleDate, causeChange, Itemname]);

  useEffect(() => {
    // if (AllDates.length > 0) {
    if (Dates != "") {
      let AD = AllDates.map((d) => d.toString());
      let SD = Dates.toString();
      setDatesSelected(AD);
      setSingleDate(SD);
    }
    // }
  }, [AllDates, Dates]);
  return (
    <Row className={classes.margin4printing}>
      <Col md={12} className={classes.margin4printing}>
        <Row className={classes.hide4printing}>
          <Col md={12}>
            <Card style={{ height: "35px" }}>
              <Card.Body>
                <h4
                  className="text-center "
                  style={{ color: "brown", fontFamily: "Times New Roman" }}
                >
                  <Divider className="m-0">ITEM HISTORY</Divider>
                </h4>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row className={classes.hide4printing}>
          <Col md={12}>
            <Card style={{ minHeight: "60px" }}>
              <Card.Body className="m-0 p-0">
                <Row className="justify-content-around align-items-center">
                  <Col md={3} sm={12} xs={12} className="text-center pl-4">
                    <label>Item name</label>
                    <AutoComplete
                      data={AllGoodNames}
                      value={
                        Itemname.charAt(0).toUpperCase() + Itemname.slice(1)
                      }
                      onChange={setItemname}
                      onSelect={getItemnameSelection}
                      onBlur={getTypedText}
                      style={{ border: "1px solid brown", marginLeft: "20px" }}
                    />
                  </Col>
                  <Col
                    md={3}
                    sm={12}
                    xs={12}
                    className="mt-1"
                    style={{ paddingLeft: "120px" }}
                  >
                    <p className="m-0 p-0 ml-5">
                      <label className={classes.labelradio}>
                        <input
                          type="radio"
                          defaultChecked={true}
                          name="datetype"
                          value="specific"
                          onChange={dateCategoryChange}
                        />
                        {" Specific Date"}
                      </label>
                    </p>
                    <p className="m-0 p-0">
                      <label className={classes.labelradio}>
                        <input
                          type="radio"
                          name="datetype"
                          value="range"
                          onChange={dateCategoryChange}
                        />
                        {" Range"}
                      </label>
                    </p>
                  </Col>
                  <Col md={3} sm={12} xs={12} className="text-center">
                    <label className={classes.labelradio}>
                      Please pick a date
                      <br />
                      <DatePicker
                        value={Dates}
                        editable={false}
                        style={{ border: "1px solid brown", height: "30px" }}
                        placeholder="Click me to open calendar!"
                        onChange={(dateObjects) => {
                          setDisplayTab(false);
                          setdisableButton(false);
                          setDates(dateObjects);
                          setAllDates(getAllDatesInRange(dateObjects));
                        }}
                        format="MMM DD, YYYY"
                        range={DateCategory === "range" ? true : false}
                        shadow={true}
                      />
                    </label>
                  </Col>
                  <Col
                    md={3}
                    sm={12}
                    xs={12}
                    className="align-self-center text-center"
                  >
                    <Button
                      variant="info"
                      onClick={GetTheHistory}
                      disabled={disableButton}
                      style={{ backgroundColor: "brown", color: "white" }}
                    >
                      Generate History
                    </Button>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        {DisplayTab && (
          <Row className={classes.margin4printing}>
            <Col md={12} sm={12} xs={12} className={classes.margin4printing}>
              <Tabs
                defaultActiveKey="allhistory"
                id="uncontrolled-tab-example"
                className={`${classes.hide4printing} ${"mb-3"}`}
                style={{ border: "1px brown solid" }}
              >
                <Tab
                  eventKey="allhistory"
                  title="All History"
                  className={classes.margin4printing}
                >
                  <AllHistory
                    Records={AllHistoryRecord}
                    myDates={DatesToSend}
                    TableToShow={TableToShow}
                    Itemname={Itemname}
                    // DeleteFunction={DeleteItem}
                  />
                </Tab>
                <Tab
                  eventKey="supplyhistory"
                  title="Supply History"
                  className={classes.margin4printing}
                >
                  <SupplyHistory
                    Records={AllSupplyHistory}
                    myDates={DatesToSend}
                    Itemname={Itemname}
                  />
                </Tab>
                <Tab
                  eventKey="saleshistory"
                  title="Sales History"
                  className={classes.hide4printing}
                >
                  <SalesHistory
                    Records={AllSalesHistory}
                    myDates={DatesToSend}
                    Itemname={Itemname}
                  />
                </Tab>
                <Tab
                  eventKey="pricehistory"
                  title="Price History"
                  className={classes.hide4printing}
                >
                  <PriceHistory
                    Records={AllPriceHistory}
                    myDates={DatesToSend}
                    Itemname={Itemname}
                  />
                </Tab>
              </Tabs>
            </Col>
          </Row>
        )}
      </Col>
      {ShowProcessing && <ProcessingModal Show={ShowProcessing} />}
    </Row>
  );
};

export default GetHistory;
